import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import MenuLeftAdminLealtad from "../componentsProveedorComercializadorLealtad/MenuLeftAdminLealtad/menuLeftAdminLealtad";
import MenuPhoneAdminLealtad from "../componentsProveedorComercializadorLealtad/MenuLeftAdminPhoneLealtad/menuLeftAdminPhone";
import ProfileProvAdminLealtad from "../ProfileProvAdminLealtad/ProfileProvAdminLealtad";
import UpdateExcelProvAdminLealtad from "../UpdateExcelProvAdminLealtad/UpdateExcelProvAdminLealtad";
import CreateExcelProvComercializadorAdmin from "../CreateExcelProvComercializadorAdminLealtad/CreateExcelProvComercializadorAdminLealtad";
import ChangePasswordAdminLealtad from "../ChangePasswordAdminLealtad/ChangePasswordAdminLealtad";
import CreateExcelProvAdminLealtad from "../CreateExcelProveedorLealtad/CreateExcelProveedorLealtad";
import ReportProvComercializadorAdminLealtad from "../ReportsProveedorComercializadorAdminLealtad/ReportProvComercializadorAdminLealtad";
import ReportProveedorAdminxmlLealtad from "../ReportProveedorAdminxmlLealtad/ReportProveedorAdminxmlLealtad";
import WelcomeLealtad from "../welcomeLealtad/welcomeLealtad";
import "../IndexProveedorComercializadorLealtad/IndexProveedorComercializadorLealtad.css";

const IndexProvAdminLealtad = () => {
  const [viewSeeProv, setViewPageProv] = useState(null);
  const location = useLocation();
  let data = location.state;

  const tipeviewSee = (datos) => {
    setViewPageProv(datos);
  };

  if (!data) {
    const storedData = sessionStorage.getItem("Data");
    if (storedData) {
      data = JSON.parse(storedData);
    }
  } else {
    // Almacena los datos en sessionStorage si están disponibles
    sessionStorage.setItem("Data", JSON.stringify(data));
  }

  return (
    <div className="boxprovmenuallmenulealtad">
      <MenuLeftAdminLealtad viewSee={tipeviewSee} />
      <MenuPhoneAdminLealtad viewSee={tipeviewSee} />
      {viewSeeProv === "Perfil" ? <ProfileProvAdminLealtad data={data} /> : null}
      {viewSeeProv === "ExcelComer" ? (
        <CreateExcelProvComercializadorAdmin />
      ) : null}
      {viewSeeProv === "ExcelSales" ? <UpdateExcelProvAdminLealtad /> : null}
      {viewSeeProv === "ExcelProv" ? <CreateExcelProvAdminLealtad /> : null}
      {viewSeeProv === "Contraseña" ? (
        <ChangePasswordAdminLealtad data={data} />
      ) : null}
      {viewSeeProv === "ListProveedordescarga" ? (
        <ReportProvComercializadorAdminLealtad data={data} />
      ) : null}
      {viewSeeProv === "xmldowload" ? (
        <ReportProveedorAdminxmlLealtad data={data} />
      ) : null}

      {viewSeeProv === null && <WelcomeLealtad data={data} />}
    </div>
  );
};

export default IndexProvAdminLealtad;
